export default __webpack_public_path__ + "static/media/twitter.171733ac.svg";